import { useState } from "react";

export const AccessCard = ({ sessionId, visitorId, api, onInside }) => {
  const [code, setCode] = useState("");
  const [done, setDone] = useState(null);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!code.trim()) return;
    setBusy(true);
    setError("");
    try {
      const res = await fetch(`${api}/access/verify`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ session_id: sessionId, code: code.trim(), visitor_id: visitorId }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(typeof data.detail === "string" ? data.detail : "That code doesn't check out.");
      setDone(data);
      onInside?.(data);
    } catch (err) {
      setError(err.message || "That code doesn't check out.");
    }
    setBusy(false);
  };

  if (done) {
    return (
      <div className="rounded-2xl border border-[#2E2E2E] bg-[#111111] p-6 max-w-2xl" data-testid="access-success">
        <p className="text-base font-medium text-white leading-[1.6]">
          Welcome back, {done.name}. You're in — {done.project || done.company || "your line is open"}.
        </p>
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="relative overflow-hidden rounded-2xl border border-[#2E2E2E] bg-[#111111] p-6 md:p-8 max-w-2xl space-y-4" data-testid="access-card">
      <div className="absolute top-0 left-0 w-full h-1 bg-[#DC2626]" />
      <p className="text-base font-bold text-[#FF5C5C] pt-1">Client access</p>
      <p className="text-base font-medium text-[#D6D6D6] leading-[1.6]">
        Already working with Dane? Enter your access code and you'll go straight through — no forms.
      </p>
      <div className="flex flex-col sm:flex-row gap-3">
        <input
          value={code}
          onChange={(e) => setCode(e.target.value.toUpperCase())}
          placeholder="DL-XXXX-XXXX"
          data-testid="access-code-input"
          className="flex-1 rounded-xl bg-[#050505] border border-[#2E2E2E] px-4 py-3 text-base font-medium tracking-[0.15em] text-white placeholder:text-[#D6D6D6] outline-none focus:border-[#FF5C5C] transition-colors duration-150"
        />
        <button type="submit" disabled={busy || !code.trim()} data-testid="access-submit-button"
          className="rounded-xl bg-white text-black font-semibold text-base px-8 py-3 hover:bg-[#D6D6D6] disabled:opacity-40 transition-colors duration-150">
          {busy ? "Checking..." : "Enter"}
        </button>
      </div>
      {error && <p className="text-base font-semibold text-[#FF5C5C]" data-testid="access-error">{error}</p>}
      <p className="text-base font-medium text-[#D6D6D6]">Don't have a code? Just say so in the chat and we'll get you set up the standard way.</p>
    </form>
  );
};
